import ApiService from "./ApiService";
import AuthService from "./AuthService";
import UserService from "./UserService";

function subscriptionSuccessUrl(planData) {
    if (typeof window === "undefined" || !window.location?.origin) {
        return "";
    }
    const base = String(window.location.origin).replace(/\/$/, "");
    const path = planData?.successPath;
    const url = typeof path === "string" && path.startsWith("/")
        ? `${base}${path}`
        : `${base}/subscription/success`;
    const joiner = url.includes("?") ? "&" : "?";
    return `${url}${joiner}session_id={CHECKOUT_SESSION_ID}`;
}

const SubscriptionService = {
    /**
     * @param {{ productKey?: string, priceKey?: string }} planData - From SUBSCRIPTION_PLANS entry
     * @param {string} customerEmail
     */
    createCheckoutSession: async (planData, customerEmail) => {
        try {
            const product_key = planData?.productKey;
            const price_key = planData?.priceKey;
            if (!product_key || !price_key) {
                return {
                    success: false,
                    error: "Please select a paid plan to continue."
                };
            }

            const requestBody = {
                product_key,
                price_key,
                quantity: 1,
                currency: planData?.currency || "USD",
                successUrl: subscriptionSuccessUrl(planData),
                customer_email: customerEmail
            };
            if (planData?.packId) {
                requestBody.pack_id = planData.packId;
            }

            const response = await ApiService.postData("/home/stripe/checkout/sessions", requestBody);
            return {
                success: true,
                data: response
            };
        } catch (error) {
            console.error("Error creating checkout session:", error);
            return {
                success: false,
                error: error.message || "Failed to create checkout session"
            };
        }
    },

    confirmCheckoutSession: async (sessionId) => {
        if (!sessionId) return { success: false };
        const response = await ApiService.postData("/home/stripe/checkout/sessions/confirm", { sessionId });
        if (response && typeof response === "object" && (response.code === "FAILURE" || response.error)) {
            throw new Error(response.message || response.error || "Could not confirm checkout");
        }
        return { success: true, data: response };
    },

    handleSubscribe: async (selectedPlan, plans) => {
        try {
            // Check if user is logged in
            const user = await AuthService.getUser();
            if (!user) {
                return {
                    success: false,
                    requiresLogin: true,
                    error: 'User not logged in'
                };
            }

            // Get user email
            const userData = await UserService.getUserInfo();
            if (!userData || !userData.user || !userData.user.email) {
                return {
                    success: false,
                    error: 'Unable to get your email address. Please try again.'
                };
            }

            const userEmail = userData.user.email;
            const selectedPlanData = plans[selectedPlan];
            if (!selectedPlanData) {
                return {
                    success: false,
                    error: "Unknown plan selected."
                };
            }

            const result = await SubscriptionService.createCheckoutSession(selectedPlanData, userEmail);

            if (result.success && result.data && result.data.url) {
                // Redirect to Stripe checkout
                window.location.href = result.data.url;
                return {
                    success: true,
                    redirecting: true
                };
            } else {
                return {
                    success: false,
                    error: result.error || 'Failed to create checkout session. Please try again.'
                };
            }
        } catch (error) {
            console.error('Subscription error:', error);
            return {
                success: false,
                error: error.message || 'Subscription failed. Please try again.'
            };
        }
    }
};

export default SubscriptionService;

